// src/utils/roleUtils.js

/**
 * Checks if the current user has the "Admin" role assigned in any of their
 * active roles / sites, current role, or user profile.
 *
 * @param {Array} [authSites] Optional sites array from Redux state.auth.sites
 * @returns {boolean}
 */
export function isUserAdmin(authSites = null) {
  try {
    const isAdminName = (val) => {
      if (!val) return false;
      const str = String(val).toLowerCase().trim();
      return str === 'admin';
    };

    // 1. Check selectedSubscrSite in localStorage
    try {
      const subscr = JSON.parse(localStorage.getItem('selectedSubscrSite') || '{}');
      if (isAdminName(subscr?.roleName) || isAdminName(subscr?.roleId?.roleName)) {
        return true;
      }
    } catch (e) {
      // ignore JSON parse error
    }

    // 2. Check availableRoles in localStorage
    try {
      const availableRoles = JSON.parse(localStorage.getItem('availableRoles') || '[]');
      if (Array.isArray(availableRoles)) {
        const found = availableRoles.some(
          (r) => isAdminName(r?.roleName) || isAdminName(r?.roleId?.roleName) || isAdminName(r?.name)
        );
        if (found) return true;
      }
    } catch (e) {
      // ignore JSON parse error
    }

    // 3. Check Redux sites passed as argument
    if (Array.isArray(authSites)) {
      const found = authSites.some(
        (r) => isAdminName(r?.roleName) || isAdminName(r?.roleId?.roleName) || isAdminName(r?.name)
      );
      if (found) return true;
    }

    // 4. Check sessionStorage rolesPresent
    try {
      const rolesPresent = JSON.parse(sessionStorage.getItem('rolesPresent') || '[]');
      if (Array.isArray(rolesPresent)) {
        const found = rolesPresent.some(
          (r) => isAdminName(r?.roleName) || isAdminName(r?.roleId?.roleName) || isAdminName(r?.name)
        );
        if (found) return true;
      }
    } catch (e) {
      // ignore JSON parse error
    }

    // 5. Check user in localStorage
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user?.isAdmin) return true;
      if (Array.isArray(user?.roles)) {
        const found = user.roles.some(
          (r) => isAdminName(r?.roleName) || isAdminName(r?.roleId?.roleName) || isAdminName(r?.name)
        );
        if (found) return true;
      }
    } catch (e) {
      // ignore JSON parse error
    }
  } catch (error) {
    console.error('Error in isUserAdmin helper:', error);
  }

  return false;
}

